var combine, distinct, map;

combine = require('../functions/combine');

distinct = require('./distinct');

map = require('./map');

module.exports = function(other) {
  return distinct.call(map.call(combine(this, other), function(arg) {
    var a, b;
    a = arg[0], b = arg[1];
    return a || b;
  }));
};
